var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.selectWidget}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.widget.label || _vm.widget.title)+" ")]),_c('v-list-item-subtitle',{staticClass:"font-italic"},[_vm._v(" "+_vm._s(_vm.$t('lastUpdated'))+": "+_vm._s(_vm.formatChangedTimestamp)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }